import { useState } from 'react';

import { Button } from '@mui/material';

import { ConfirmModal } from 'components/modal';
import { useLoadF360 } from 'pages/financeiro/dre/hooks';

export function DreLoadF360Btn() {
    const [openConfirmModal, setOpenConfirmModal] = useState<boolean>(false);
    const { loadF360 } = useLoadF360();

    return (
        <>
            <ConfirmModal
                open={openConfirmModal}
                setOpen={setOpenConfirmModal}
                confirm={loadF360}
                text="Ao carregar as despesas do F360 todos os dados das seções Despesas, Despesas Extras e Impostos serão substituídos. Tem certeza que deseja continuar?"
            />

            <Button variant="outlined" onClick={() => setOpenConfirmModal(true)}>
                Carregar Despesas F360
            </Button>
        </>
    );
}
